import i18n from 'i18next';

export const getEnabledStatusFilterOptions = () => [
  { value: true, label: i18n.t('enabled', { ns: 'common' }) },
  { value: false, label: i18n.t('disabled', { ns: 'common' }) }
];

export const getOnlineStatusFilterOptions = () => [
  { value: true, label: i18n.t('online', { ns: 'common' }) },
  { value: false, label: i18n.t('offline', { ns: 'common' }) }
];

export const getActiveStatusFilterOptions = () => [
  { value: true, label: i18n.t('active', { ns: 'common' }) },
  { value: false, label: i18n.t('inactive', { ns: 'common' }) }
];

export const getTributeVideoExportStatusOptions = () => [
  { value: 'preparing', label: i18n.t('preparing', { ns: 'common' }) },
  { value: 'pending', label: i18n.t('pending', { ns: 'common' }) },
  { value: 'inprogress', label: i18n.t('inprogress', { ns: 'common' }) },
  { value: 'completed', label: i18n.t('completed', { ns: 'common' }) },
  { value: 'failed', label: i18n.t('failed', { ns: 'common' }) },
  { value: 'canceled', label: i18n.t('canceled', { ns: 'common' }) }
];
